import React from 'react';

interface ProjectCardProps {
  title: string;
  image: string;
  description: string;
  technologies?: string[];
  link?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function ProjectCard({ title, image, description, technologies, link, className = '', style }: ProjectCardProps) {
  return (
    <div className={`group relative overflow-hidden rounded-lg bg-stone-700/30 backdrop-blur-sm border border-stone-600/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:shadow-green-900/20 ${className}`} style={style}>
      {/* Image Container */}
      <div className="relative h-64 overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-stone-900 via-stone-900/50 to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-300" />
      </div>
      
      {/* Content */}
      <div className="p-6">
        <h3 className="text-amber-100 mb-3">{title}</h3>
        
        {/* Description - hidden by default, shown on hover */}
        <div className="max-h-0 overflow-hidden opacity-0 group-hover:max-h-96 group-hover:opacity-100 transition-all duration-500 ease-in-out">
          <p className="text-stone-300 mb-4 leading-relaxed">
            {description}
          </p>
          
          {technologies && technologies.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-4">
              {technologies.map((tech, index) => (
                <span 
                  key={index}
                  className="px-3 py-1 bg-green-800/30 text-green-300 rounded-full text-sm border border-green-700/30"
                >
                  {tech}
                </span>
              ))}
            </div>
          )}
          
          {link && (
            <a 
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-green-700 hover:bg-green-600 text-white rounded-md transition-colors duration-200"
            >
              View Project
              <svg 
                className="w-4 h-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                />
              </svg>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}